let code = 'gim';
let codeAPI = 'gim';
export const apiConstants = {
    code: `${code}`,
    codeAPI: `${codeAPI}`,
};
